import {
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-extension-manager',
});

export const TECH_ADAPTERS_TAB_ROUTE = '/tech-adapters';

export const WEBHOOKS_TAB_ROUTE = '/webhooks';

export const TECHNOLOGIES_TAB_ROUTE = '/technologies';

export const techAdapterDetailRef = createSubRouteRef({
  parent: rootRouteRef,
  id: 'tech-adapter-detail',
  path: '/tech-adapters/:id',
});

export const webhookDetailRef = createSubRouteRef({
  parent: rootRouteRef,
  id: 'webhook-detail',
  path: '/webhook/:uuid',
});

export const testPolicyPageRef = createExternalRouteRef({
  id: 'test-policy-page',
  params: ['policyId', 'env'],
});
